namespace Solovis.Reports.Parts.Tables {

    export interface ColumnListChoiceControlOptions extends Solovis.UI.BaseControlOptions {
        columnSet: DataTableHelpers.ColumnSet;
        selectedColumnIds: string[];
    }

    export class ColumnListChoiceControl extends Solovis.UI.BaseControl {

        private _options: ColumnListChoiceControlOptions;

        private _columnListEditorDiv;
        private _columnListEditor;

        constructor(options: ColumnListChoiceControlOptions) {
            super(options);

            this._options = options;
        }

        public doRender() {
            let self = this;

            this._columnListEditorDiv = $("<div>").appendTo(this.container);
            this._columnListEditor = new Solovis.UI.VerticalOrderedListBuilder({
                controlHost: this._columnListEditorDiv,

                itemTypeLabel: "Column",
                showEditLinks: false,

                values: this._options.selectedColumnIds,

                editorCreator: function (editorDiv, initialValue) {
                    let columnChoiceControl = new ColumnChoiceControl({
                        controlHost: editorDiv,
                        columnSet: self._options.columnSet,
                        selectedColumnId: initialValue
                    });
                    columnChoiceControl.setAsCurrentControl();

                    var editorInfo = {
                        getValue: function () {
                            return columnChoiceControl.getValue();
                        },
                        destroy: function () {
                            columnChoiceControl.controlHost.setCurrentControl(null);
                        }
                    };

                    return editorInfo;
                },

                newValueGenerator: function () {
                    return null;
                }
            });
            this._columnListEditor.setAsCurrentControl();
        }

        public value(newValue?: string) {
            if (arguments.length === 0) {
                if (this._columnListEditorDiv) {
                    let columnIdList = this._columnListEditor.getValues();
                    return columnIdList;
                }
                else {
                    return this._options.selectedColumnIds;
                }
            }
            else {
                console.log("ColumnListChoiceControl does not currently support setting the value.");
            }
        }

        public getValue() {
            return this.value();
        }        
    }
}